module.exports = __webpack_public_path__ + "img/erau-logo.6af616c3.png";